import {
    GET_COUNTRY_LIST_REQUEST,
    GET_COUNTRY_LIST_SUCCESS,
    GET_COUNTRY_LIST_FAILURE,
    POST_NEW_CUSTOMER_REQUEST,
    POST_NEW_CUSTOMER_SUCCESS,
    POST_NEW_CUSTOMER_FAILURE,
    GET_LANGUAGE_LIST_REQUEST,
    GET_LANGUAGE_LIST_SUCCESS,
    GET_LANGUAGE_LIST_FAILURE,
    RESET_NEW_CUSTOMER_MESSAGE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    countryList: [],
    languageList: [],
    error: null,
    account: {
        accountName: null,
        accountDescription: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        state: null,
        zipCode: null,
        countryId: 0,
        defaultLocaleId: 0,
    },
    admin: {
        loginName: null,
        firstName: null,
        lastName: null,
    },
    message: undefined,
    shouldReset: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_COUNTRY_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                countryList: action.payload.countryList,
                isInitialFetch: false,
            };
        case GET_COUNTRY_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case GET_LANGUAGE_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_LANGUAGE_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                languageList: action.payload.languageList,
                isInitialFetch: false,
            };
        case GET_LANGUAGE_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case POST_NEW_CUSTOMER_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case POST_NEW_CUSTOMER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message,
                account: {
                    accountName: null,
                    accountDescription: null,
                    addressLine1: null,
                    addressLine2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    countryId: 0,
                    defaultLocaleId: 0,
                },
                admin: {
                    loginName: null,
                    firstName: null,
                    lastName: null,
                },
                isInitialFetch: false,
                shouldReset: true
            };
        case POST_NEW_CUSTOMER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.message || action.payload?.error?.message,
            };
        case RESET_NEW_CUSTOMER_MESSAGE:
            return {
                ...state,
                isLoading: false,
                message: undefined,
                isInitialFetch: false,
                shouldReset: false
            };
        default:
            return state;
    }
};